import { GET_RECIPES, SET_LOADING, ADD_RECIPE, RECIPE_ERROR } from "../Actions";

const initialState = {
	recipes: [],
	loading: false,
	error: null,
	// recipe_id: 0,
	// recipe_title: "",
	// recipe_source: "",
	// image: "",
	// user_id: 0,
	// category_id: 0,
};

export default function myFunc(state = initialState, action) {
	switch (action.type) {
		default:
			return state;
		case GET_RECIPES:
			return { ...state, recipes: action.payload, loading: false };
		case SET_LOADING:
			return { ...state, loading: true };
		case ADD_RECIPE:
			return {
				...state,
				recipes: [...state.recipes, action.payload],
				loading: false,
			};
		case RECIPE_ERROR:
			return { ...state, error: action.payload, loading: true };
	}
}
